__turbopack_context__.v({
  "age": "PartnerCard-module__NyEYWa__age",
  "card": "PartnerCard-module__NyEYWa__card",
  "collected": "PartnerCard-module__NyEYWa__collected",
  "donateDetails": "PartnerCard-module__NyEYWa__donateDetails",
  "donateNow": "PartnerCard-module__NyEYWa__donateNow",
  "goal": "PartnerCard-module__NyEYWa__goal",
  "nametext": "PartnerCard-module__NyEYWa__nametext",
  "prgresstext": "PartnerCard-module__NyEYWa__prgresstext",
  "prog": "PartnerCard-module__NyEYWa__prog",
  "progressbar": "PartnerCard-module__NyEYWa__progressbar",
  "projectContent": "PartnerCard-module__NyEYWa__projectContent",
  "projectImage": "PartnerCard-module__NyEYWa__projectImage",
  "projectImageSize": "PartnerCard-module__NyEYWa__projectImageSize",
  "projectdonate": "PartnerCard-module__NyEYWa__projectdonate",
  "projectdonatep": "PartnerCard-module__NyEYWa__projectdonatep",
  "projectprgresslrg": "PartnerCard-module__NyEYWa__projectprgresslrg",
});
